import { archiveReducer } from './archive/reducers';
import { messageReducer } from './message/reducers';
import { authReducer } from './authentication/reducers';

export const rootReducer = {
  auth: authReducer,
  archive: archiveReducer,
  message: messageReducer,
};
